import React from "react";

const ASP_Request = () => {
  return (
    <div className="tutorial-page">
      <h1>ASP Request</h1>
      <p>This is the ASP Request page content.</p>
    </div>
  );
};

export default ASP_Request;
